import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { InksofteditorAPIInterface, InksofteditorInterfaceData, ArtworkPlacement } from '@app/shared/components/inksofteditor/inksofteditor.interface';
import { IUserLocalDetails } from '@app/core/services/localStorage/Ilocal-storage.interface';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { CommonService } from '@app/shared/services/common/common.service';

declare var launchDesigner: any;
declare var window: any;

@Component({
  selector: 'app-inksofteditor',
  templateUrl: './inksofteditor.component.html',
  styleUrls: ['./inksofteditor.component.css']
})
export class InksofteditorComponent implements OnInit {
  categoryId !: string;
  styleId !: string;
  productId !: string;
  inksoftuserId!: any;
  designId!: any;
  userRole!: any;
  inkSoftDesignUrl = '';
  parentRouteParam!: any;
  shopifyEditing: boolean;
  user: IUserLocalDetails;
  artworks: ArtworkPlacement[] = [];
  @Input() data: InksofteditorInterfaceData | null = null;
  @Input() addProductPopup = false;
  @Output() NewDesignData = new EventEmitter<InksofteditorAPIInterface>();

  constructor(private activatedRoute: ActivatedRoute, private router: Router,
    private ls: LocalStorageService, private common: CommonService) {
    this.common.subShopifyDesign().subscribe((res: { shopify: boolean }) => {

      this.shopifyEditing = res.shopify;
    });

    this.user = ls.getObject<IUserLocalDetails>(new IUserLocalDetails());
    if (this.activatedRoute.parent) {
      this.activatedRoute.parent.params.subscribe(params => {
        this.parentRouteParam = params['storename'];
      });
    }
  }

  loadInputs() {
    if (this.data) {
      this.categoryId = this.data.categoryId;
      this.styleId = this.data.styleId;
      this.productId = this.data.productId;
      this.designId = this.data.designId;
      this.artworks = this.data.artworks || [];
    }
  }

  ngOnInit() {
    if (!this.addProductPopup) {
      this.activatedRoute.queryParams.subscribe(params => {
        this.categoryId = params.cid;
        this.styleId = params.styleid;
        this.productId = params.pid;
        this.designId = params.designId;

        if (params.hasOwnProperty('url')) {
          this.inkSoftDesignUrl = environment.frontEnd_BaseUrl + decodeURIComponent(params.url);

        }
      });
    }

    this.loadInputs();
    localStorage.setItem('productIdToBeDesigned', this.productId);
    localStorage.setItem('styleIdToBeDesigned', this.styleId);
    this.inksoftuserId = localStorage.getItem('inksoftUserId');
    this.userRole = localStorage.getItem('role');
    if (this.inkSoftDesignUrl === '') {
      if (this.userRole === 'EndUser') {
        this.inkSoftDesignUrl = environment.frontEnd_BaseUrl + this.parentRouteParam + '/saveddesigns?designID=0';
      } else if (this.userRole === 'StoreAdmin' || this.userRole === 'StoreOwner' || this.userRole === 'StoreStaffMember') {
        // if (this.designId !== 0 && this.designId !== null && this.designId !== undefined) {
        //    localStorage.setItem('oldDesignID', this.designId);
        // }
        // this.inkSoftDesignUrl = environment.frontEnd_BaseUrl + `/store/customizedproducts?designID=0`;
      }
    }
    // INKSOFT DISABLED (2026-09): do not launch the InkSoft design studio from the routed
    // /product/customize editor. Store-admin creation/editing uses Design Huddle; end-user
    // self-customize is dead (CanEndUserCustomize=0 for all stores). Launch guarded off.
    // this.loadEditorV2(this.productId, this.categoryId, this.styleId, this.designId, this.inksoftuserId,
    //   this.userRole, this.inkSoftDesignUrl);
  }



  loadEditorV2(productId: any, categoryid: any, styleid: any, designId: any, insoftUserId: any, userRole: any, inkSoftDesignUrl: string) {
    const scriptElement = document.createElement('script');
    scriptElement.type = 'text/javascript';
    scriptElement.async = true;
    scriptElement.src = 'https://stores.inksoft.com/FrontendApps/storefront/assets/scripts/designer-embed.js';
    const artworksToLoad = this.artworks;

    scriptElement.onload = () => {
      // Build config object
      const config: any = {
        targetElementId: 'embeddedDesigner',
        domain: 'https://stores.inksoft.com',
        cdnDomain: 'https:https://cdn.inksoft.com',
        storeUri: 'DS304263396',
        productId: productId,
        productStyleId: styleid,
        designId: designId,
        disableCart: true,
        sessionToken: this.user.inksoftToken,
        disableLeavePrompt: true,
        disableAddColors: true,
        onDesignSaved: (designData: InksofteditorAPIInterface) => {
          if (this.addProductPopup) {
            var payload = {
              ProductStyleId: designData.ProductStyleId,
              Uri: designData.Uri,
              Notes: designData.Notes,
              Name: designData.Name,
              ID: designData.ID,
              Canvases: designData.Canvases,
              OldDesignId: designId
            }
            this.NewDesignData.emit(payload);
          } else {
            const baseUrl = this.shopifyEditing ? environment.baseUrlShopifyApp : environment.frontEnd_BaseUrl;
            if (this.userRole === 'EndUser') {
              // @ts-ignore
              document.location = baseUrl + this.parentRouteParam + `/saveddesigns?designID=${designData.ID}`;
            }
          }
        },
        onDesignerReady: (data: any) => {
          console.log('Designer ready');
          // Note: InkSoft API only exposes 'launchEmbeddedDesignStudio' and 'embeddedDesignStudios'
          // There is no API method to add artwork programmatically after the designer loads.
          // Artworks must be added manually by the user using the editor's built-in upload feature.
        }
      };

      // @ts-ignore
      window.inksoftApi.launchEmbeddedDesignStudio(config);
    }
    document.getElementsByTagName('body')[0].appendChild(scriptElement);
  }
}
